import React from 'react';

const BiographyHeader = () => {
    return(
        <>
            <section class="intro-about section-margin" style={{marginBottom: '0px'}}>
                    <div class="container" style={{paddingBottom: '50px'}}>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="intro-content-text" style={{paddingTop: '90px'}}>

                                    <h2 data-dsn-grid="move-section" data-dsn-move="-30" data-dsn-duration="100%"
                                        data-dsn-opacity="1.2" data-dsn-responsive="tablet" style={{color:'#000', textAlign: 'center'}}>
                                        Meet Pawan Chamling
                                    </h2>

                                    <p class="economy-page-header-desc" style={{fontSize: '1rem', fontWeight: '500', maxWidth:'100%', color:'#000', textAlign: 'center', paddingLeft: '80px', paddingRight: '80px'}}>
                                     A politician, poet, writer, a fearless voice of the people and a leader of the masses, meet Pawan Chamling, born in the lap of Bhaley Dhunga who introduced Sikkim to the world.  
                                    </p>


                                </div>
                            </div>

                        </div>
                    </div>

                </section>
        </>
    );
};

export default BiographyHeader;